import { createElement } from "react";

// Static wrappers kept so existing pages render unchanged; no scroll animation.
const tag = (as) => as || "div";

export function Reveal({ children, className = "", as = "div" }) {
  return createElement(tag(as), { className }, children);
}

export function RevealGroup({ children, className = "" }) {
  return <div className={className}>{children}</div>;
}

export function Item({ children, className = "", as = "div", ...rest }) {
  const { variants, initial, animate, whileInView, viewport, transition, ...dom } = rest;
  return createElement(tag(as), { className, ...dom }, children);
}

export const revealItem = {};
